// The compatibility date, compatibility flags, Durable Object classes, and
// migration tag below are mirrored in Ignition, which builds its own Worker
// metadata at deploy time (pkg/cloudflare/upload/metadata.go and
// pkg/cloudflare/upload/migrations/migrations.go). Keep both sides in sync
// when changing any of them.
export function getCompatibilityDate(now = new Date()): string {
  const date = new Date(now);

  // One month behind the current date: recent enough to track Cloudflare
  // runtime behavior (per Cloudflare guidance), buffered enough to avoid
  // brand-new compatibility-date-gated changes. Ignition applies the same
  // offset at deploy time, so the bundle is never built against newer
  // semantics than it runs under.
  date.setUTCMonth(date.getUTCMonth() - 1);

  return date.toISOString().slice(0, 10);
}

export function getWranglerConfig(projectUuid: string) {
  return {
    $schema: 'node_modules/wrangler/config-schema.json',
    main: '../.open-next/worker.js',
    name: `project-${projectUuid}`,
    compatibility_date: getCompatibilityDate(),
    compatibility_flags: ['nodejs_compat', 'global_fetch_strictly_public'],
    observability: {
      enabled: true,
      head_sampling_rate: 0.05,
      logs: {
        enabled: true,
        head_sampling_rate: 1,
        invocation_logs: false,
      },
    },
    assets: {
      directory: '../.open-next/assets',
      binding: 'ASSETS',
    },
    services: [
      {
        binding: 'WORKER_SELF_REFERENCE',
        service: `project-${projectUuid}`,
      },
    ],
    r2_buckets: [
      {
        binding: 'NEXT_INC_CACHE_R2_BUCKET',
        bucket_name: `project-${projectUuid}`,
      },
    ],
    durable_objects: {
      bindings: [
        {
          name: 'NEXT_CACHE_DO_QUEUE',
          class_name: 'DOQueueHandler',
        },
        {
          name: 'NEXT_TAG_CACHE_DO_SHARDED',
          class_name: 'DOShardedTagCache',
        },
        {
          name: 'NEXT_CACHE_DO_PURGE',
          class_name: 'BucketCachePurge',
        },
      ],
    },
    migrations: [
      {
        tag: 'v1',
        new_sqlite_classes: ['DOQueueHandler', 'DOShardedTagCache', 'BucketCachePurge'],
      },
    ],
  };
}
